import React, { PropTypes } from 'react';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import AddItemCard from '../../generic-components/add-item-card/add-item-card';
import EditButton from '../../generic-components/edit-button';
import MouseOverEditDiv from '../../../tc-ui/mouse-over-edit-div';
import ActivityWithIcon from '../../generic-components/activity-with-icon';
import moment from 'moment';
import HelperLink from '../product/helper-link';


export const BillingInfoDisplay = props => {
  const {
    inMaster,
    hideLabel,
    supplierEditable,
    openAddEditContractDialog,
    classes = {},
    ...billingInfo,
  } = props;
  const {
    terms,
    financialInstitution,
    branch,
    accountName,
    accountNumber,
    bsbRoutingNumber,
    ibanSwiftCode,
    currency,
  } = billingInfo;
  const editBillingInfo = () => openAddEditContractDialog({
    type: 'billingInfo',
    title: 'Edit billing information',
  });
  return (
    <div id="billingInfo">
      <HelperLink
        value="billingInfo"
        labelText={!hideLabel && 'Billing Information'}
        openEditDialog={editBillingInfo}
        justLabel={inMaster}
      />
      <MouseOverEditDiv
        extendPadding
        editable={supplierEditable}
        actionButtons={<EditButton
          onEdit={editBillingInfo}
        />}
      >
        <div
          style={{ marginBottom: '20px', display: terms ? 'block' : 'none', whiteSpace: 'pre-wrap' }}
          className={classes['terms-textblock'] ? '' : classes['terms']}
        >
          {classes['terms-textblock'] || terms}
        </div>
        <TwoColumnRow
          hide={!(financialInstitution && branch)}
          outerContainerStyle={{ marginBottom: '12px', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'Financial institution'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnContent={<div><span className={classes['financialInstitution']}>{financialInstitution}</span> - <span className={classes['branch']}>{branch}</span></div>}
        />
        <TwoColumnRow
          hide={!accountName}
          outerContainerStyle={{ marginBottom: '0', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'Account Name'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes['accountName']}
          rightColumnContent={accountName}
        />
        <TwoColumnRow
          hide={!accountNumber}
          outerContainerStyle={{ marginBottom: '0', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'Account Number'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes['accountNumber']}
          rightColumnContent={accountNumber}
        />
        <TwoColumnRow
          hide={!bsbRoutingNumber}
          outerContainerStyle={{ marginBottom: '0', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'BSB/Routing number'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes['bsbRoutingNumber']}
          rightColumnContent={bsbRoutingNumber}
        />
        <TwoColumnRow
          hide={!ibanSwiftCode}
          outerContainerStyle={{ marginBottom: '0', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'Iban/Swift code'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes['ibanSwiftCode']}
          rightColumnContent={ibanSwiftCode}
        />
        <TwoColumnRow
          hide={!currency}
          leftColumnStyle={{ width: '60%', maxWidth: '500px' }}
          leftColumnContent={'Currency'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes['currency']}
          rightColumnContent={currency}
        />
      </MouseOverEditDiv>
    </div>
  );
};

export const InsuranceInfoDisplay = props => {
  const {
    inMaster,
    hideLabel,
    supplierEditable,
    openAddEditContractDialog,
    classes = {},
    ...insuranceInfo,
  } = props;
  const {
    insuranceExpirationYear,
    insuranceExpirationMonth,
    insuranceFiles,
  } = insuranceInfo;
  const editInsurance = () => openAddEditContractDialog({
    type: 'billingInfo',
    title: 'Edit insurance information',
  });
  return (
    <div id="insuranceInfo">
      <br/>
      <br/>
      <HelperLink
        value="insuranceInfo"
        labelText={!hideLabel && 'Insurance Information'}
        openEditDialog={editInsurance}
        justLabel={inMaster}
      />
      <MouseOverEditDiv
        extendPadding
        editable={supplierEditable}
        style={{ marginTop: '16px' }}
        actionButtons={<EditButton
          onEdit={editInsurance}
        />}
      >
        <TwoColumnRow
          hide={!insuranceExpirationYear && !insuranceExpirationMonth}
          outerContainerStyle={{ marginBottom: '0', maxWidth: '500px' }}
          leftColumnStyle={{ width: '60%' }}
          leftColumnContent={'Expiration'}
          rightColumnStyle={{ textAlign: 'right' }}
          rightColumnClassName={classes.insuranceExpirationYear || classes.insuranceExpirationMonth}
          rightColumnContent={moment(new Date(insuranceExpirationYear, insuranceExpirationMonth - 1, 1)).format('MMM YYYY')}
        />
        <TwoColumnRow
          hide={!(insuranceFiles && insuranceFiles.length && insuranceFiles[0].fileName)}
          outerContainerStyle={{ marginBottom: '0', display: 'flex', flexWrap: 'wrap', maxWidth: '500px' }}
          leftColumnStyle={{ width: '40%' }}
          leftColumnContent="Uploaded document"
          rightColumnContent={
            insuranceFiles && insuranceFiles.length && insuranceFiles[0].fileName
              ? insuranceFiles.map((file, key) => (
                <div
                  key={key}
                  style={{ float: 'right', width: '100%' }}
                  className={classes[`insuranceFiles-${key}`] || classes[`insuranceFiles-${key}-fileName`] || classes[`insuranceFiles-${key}-downloadUrl`]}
                >
                  <ActivityWithIcon file={file} />
                </div>)) : <div/>
          }
          rightColumnStyle={{ width: '60%' }}
        />
      </MouseOverEditDiv>
    </div>
  );
};

const BillingInfo = props => {
  const {
    supplierEditable,
    openAddEditContractDialog,
    inMaster,
    ...billingInfo,
  } = props;
  const {
    terms,
    financialInstitution,
    branch,
    accountName,
    accountNumber,
    bsbRoutingNumber,
    ibanSwiftCode,
    currency,
    insuranceExpirationYear,
    insuranceExpirationMonth,
    insuranceFiles,
  } = billingInfo;
  const billingEmpty = !terms && !financialInstitution && !branch && !accountName && !accountNumber && !bsbRoutingNumber && !ibanSwiftCode && !currency;
  const insuranceEmpty = !insuranceExpirationYear && !insuranceExpirationMonth && !(insuranceFiles && insuranceFiles.length);
  return (
    <div style={{ marginLeft: '15%', width: '80%', paddingTop: '24px', paddingBottom: '24px', borderTop: '1px solid #efefef' }} id="billingInfo">
      <div style={{ marginBottom: '12px', fontSize: '16px' }}>BILLING & INSURANCE</div>
      <div style={{ marginLeft: '32px' }}>
        {
          billingEmpty ? (
            <div>
              <HelperLink
                value="billingInfo"
                labelText="Billing Information"
                justLabel={inMaster}
              />
              <AddItemCard
                text="Add billing information"
                onClick={() => openAddEditContractDialog({
                  type: 'billingInfo',
                  title: 'Add billing information',
                })}
                editable={supplierEditable}
              />
            </div>
          ) : (
            <BillingInfoDisplay {...props}/>
          )
        }
        {
          insuranceEmpty ? (
            <div>
              <br/>
              <br/>
              <HelperLink
                value="insuranceInfo"
                labelText="Insurance Information"
                justLabel={inMaster}
              />
              <AddItemCard
                text="Add insurance information"
                onClick={() => openAddEditContractDialog({
                  type: 'billingInfo',
                  title: 'Add insurance information',
                })}
                editable={supplierEditable}
              />
            </div>
          ) : (
            <InsuranceInfoDisplay {...props} />
          )
        }
      </div>
    </div>
  );
};

BillingInfo.propTypes = {
  insuranceFiles: PropTypes.array,
  terms: PropTypes.string,
  financialInstitution: PropTypes.string,
  branch: PropTypes.string,
  accountName: PropTypes.string,
  accountNumber: PropTypes.string,
  bsbRoutingNumber: PropTypes.string,
  ibanSwiftCode: PropTypes.string,
  currency: PropTypes.string,
  insuranceExpirationYear: PropTypes.number,
  insuranceExpirationMonth: PropTypes.number,
  addBillingInformation: PropTypes.func,
  editBillingInformation: PropTypes.func,
  openAddEditContractDialog: PropTypes.func,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
};

export default BillingInfo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/billing-info-node.jsx